<template>
  <div class="dropdown nodro item">
    <button
      class="btn no-bg text-secondary"
      type="button"
      @click="onClick">
      <i
        v-if="icon"
        :class="[icon, iconClassName]"/>
      <span :class="[textClassName]">
        {{ text }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: ['icon', 'iconClassName', 'text', 'textClassName'],

  methods: {
    onClick (value) {
      this.$emit('onClick', value)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseAction.vue